import { siteConfig } from "../../data/portfolioData";

export default function Footer() {
  return (
    <footer className="border-t border-carbon-800 bg-carbon-950 py-10 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="font-display text-lg tracking-widest text-ash-400">
          {siteConfig.name.split(" ")[0]}
          <span className="text-ember-400">.</span>
        </div>

        <p className="font-mono text-xs text-ash-600 text-center">
          © {new Date().getFullYear()} {siteConfig.name}. Crafted with intent.
        </p>

        <div className="flex items-center gap-6">
          {Object.entries(siteConfig.socialLinks).map(([platform, url]) => (
            <a
              key={platform}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-ash-600 hover:text-ember-400 uppercase tracking-widest transition-colors duration-300"
            >
              {platform}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
